import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function OffshoreCompanyFormation() {
    return (
        <main className='main'>
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>Offshore Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Incorporate Globally. Operate Without Borders.</h3>
                            <p className='page-paragraph'>
                                Expand your business internationally with our <b>offshore company registration services.</b> Offshore Advisory helps entrepreneurs, investors, and corporations establish secure and compliant offshore entities in the world’s most reputable jurisdictions.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Fast Incorporation",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Global Jurisdictions",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Banking & Licensing Support",
                                        icon: TiTick,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Proposal  →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />

                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h2 className='page-title'>Why Register an Offshore Company? </h2>
                        <p >Forming an <b>offshore company</b> provides businesses with strategic advantages in today’s global economy:</p>
                        <PageList
                            items={[
                                {
                                    title: "Global Market Access",
                                    paragraph: "Trade and operate beyond local borders.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Opportunities",
                                    paragraph: "Access international bank accounts and payment providers.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Optimization",
                                    paragraph:
                                        "Benefit from favorable tax structures (depending on jurisdiction).",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy & Asset Protection",
                                    paragraph:
                                        "Protect shareholder identity and secure corporate assets.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ease of Expansion",
                                    paragraph:
                                        "Simplify cross-border business and licensing opportunities.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-subtitle'>
                            Offshore Company Formation Services
                        </h3>
                        <p >Our end-to-end offshore company registration services include:</p>
                        <PageList
                            items={[
                                {
                                    title: "International Business Company (IBC) Formation",
                                    paragraph: "Simple, fast, and cost-effective incorporation.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Onshore + Offshore Hybrid Structures",
                                    paragraph: "Combine local credibility with offshore advantages.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Nominee Director & Shareholder Services",
                                    paragraph: "Ensure confidentiality and compliance.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Bank Account & PSP Setup",
                                    paragraph:
                                        "Guidance on opening accounts worldwide, including crypto-friendly solutions.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Licensing Support",
                                    paragraph:
                                        "Bundle with gaming, brokerage, crypto, or fintech licenses.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Maintenance & Compliance",
                                    paragraph: "Renewals, reporting, and legal support.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-subtitle'>Where Can You Register an Offshore Company?</h3>
                        <p>We cover leading <b>offshore and onshore jurisdictions,</b> including:</p>
                        <PageList
                            items={[
                                {
                                    title: "Western Sahara (CRA)",
                                    paragraph: "IBCs and iGaming Licensing Packages.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Mwali (Comoros)",
                                    paragraph: "Flexible IBCs and licensing structures.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Anjouan",
                                    paragraph: "Fast, crypto-friendly offshore formation.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Mauritius",
                                    paragraph: "Gateway between Africa and Asia.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Cyprus & Malta",
                                    paragraph: "Onshore credibility with EU compliance.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "UK",
                                    paragraph: "Strong legal framework and international banking.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-paragraph'>
                            Comparison tables available upon request.
                        </p>
                        <Button
                            text="Talk to an Expert →"
                            link="/consultation"
                            type="primary"
                            size="large"
                        />

                        <br/><br/>
                        <h3 className='page-subtitle'>
                            How It Works: Offshore Company Registration Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Initial Consultation",
                                    paragraph: "Choose the best jurisdiction based on your goals.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Document Collection",
                                    paragraph: "Passport, proof of address, and shareholder details.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Incorporation Filing",
                                    paragraph: "We prepare and submit all corporate documents.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & Add-Ons",
                                    paragraph:
                                        "Assistance with account openings, licenses, and nominees.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Ongoing Support",
                                    paragraph: "Annual renewals, compliance, and business advisory.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                        <p className='page-paragraph'> Typical timelines: <b>3–10 business days</b> depending on the jurisdiction.</p>

                        <h3 className='page-subtitle'>
                            Why Offshore Advisory?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Trusted partner for global company registration",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Transparent pricing — no hidden fees",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Expertise across gaming, fintech, and corporate sectors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking, licensing, and compliance under one roof",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "24/7 client support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />
                    </div>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Ready to take your business global?"
                        description="Let our experts help you register your offshore company today."
                        buttonText="Get a Free Consultation →"
                        buttonLink="/consultation"
                    />

                </div>

            </section>
        </main>
    )
}

export default OffshoreCompanyFormation

const faqData = [

    {
        question: "Is offshore company registration legal?",
        content: [
            {
                type: "answer",
                text: "Yes. All companies are registered under official regulators in recognized jurisdictions, and we ensure compliance with international standards." },
        ],
    },
    {
        question: "Do I need to visit in person?",
        content: [
            {
                type: "answer",
                text: "No. Offshore Advisory provides a <b>fully remote registration service.</b>" },
        ],
    },
    {
        question: "What is the cost of setting up an offshore company?",
        content: [
            {
                type: "answer",
                text: "Costs vary by jurisdiction and package. Entry-level formation typically starts from USD 700" },
        ],
    },
     {
        question: "Can I open a bank account for my offshore company?",
        content: [
            {
                type: "answer",
                text: "Yes. We assist with account setup in over <b>120 banks worldwide</b> (including crypto-friendly PSPs)." },
        ],
    },
     {
        question: "Which is the best jurisdiction for me?",
        content: [
            {
                type: "answer",
                text: "This depends on your business activity, target market, and compliance needs. Our advisors will help you select the most suitable jurisdiction." },
        ],
    },

];

const testimonialsData = [
    {
        quote:
            "Our offshore entity was incorporated in less than a week. Offshore Advisory’s team handled all compliance paperwork smoothly.",
        author: "Sarah L.",
        role: "FinTech Entrepreneur",
    },
    {
        quote:
            "They made global expansion easy. From banking to licensing, everything was managed under one roof.",
        author: "James R.",
        role: "iGaming Operator",
    },
];